import { GlobalService } from './../global.service';
import { Injectable, EventEmitter } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
// import { GlobalProviderService } from '../global-provider.service';

const TOKEN_KEY = 'auth-token';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  authendicationState = new BehaviorSubject(false);
  login_event = new EventEmitter<any>();
  menu_header = new EventEmitter<any>();
  
  constructor(private globalProvider: GlobalService, private route: Router, private httpClient: HttpClient) { }

  // async login(user_form) {
  // this.httpClient.post(`${this.globalProvider.server_url}/main/app/login/for/token/`, user_form).subscribe((data) => {
  //   console.log(data);
  //   localStorage.setItem('TOKEN_KEY', JSON.stringify(data['token']));
  //   // localStorage.setItem('first_name', JSON.stringify(data['first_name']));
  //   // localStorage.setItem('user_profile', JSON.stringify(data['user_profile']));
  //   // localStorage.setItem('user_type', JSON.stringify(data['user_profile']['user_type']));
  //   this.authendicationState.next(true);
  //   this.login_event.emit(data['token']);
  //   this.http.setTokentoHeaders(data['token']);
  //   this.route.navigateByUrl('/');
  // }, (error) => {
  //   console.log(error);
  //   const error_message = error['detail'];
  //     alert(error_message);
  // });
  // }

  async logout() {
    let data_dict = {
      'employee_id': localStorage.getItem('employee_id')
    };
    this.httpClient.post(`${this.globalProvider.server_url}/main/logout/employee/from/counter/`, data_dict).subscribe((data) => {
      this.authendicationState.next(false);
      return localStorage.clear();
    }, (error) => {
      console.error(error);
      this.authendicationState.next(false);
      return localStorage.clear();
    });
  }

  isAuthenticated() {
    return this.authendicationState.value;
  }

  async checkToken() {
    let token = JSON.parse(localStorage.getItem(TOKEN_KEY));
    if (token != null) {
      this.authendicationState.next(true);
    }
    return localStorage.getItem(TOKEN_KEY);
  }
}
